export default "__VITE_ASSET__CGsYKQuE__"